<template>
  <div class="ub ub-ver uw uh ubgc-main" >
    <div class="ub ub-ver ub-f1 ub-pc ub-ac">
      <!--<div class="ub ub-pc">-->
        <!--<img src="../../assets/image/logo.png" class="ubor-r" width="120" alt="">-->
      <!--</div>-->
      <div class="ub ub-pc ufs-24 uc-while umar-t20" >OKLOK智能锁商城系统</div>

      <div class="ub ub-ver upad-40 umar-t20 uh-400 uw-480 ubgc-while ubor-r6">
<!--        <div class="ub ">-->
<!--          <el-radio-group v-model="radio.index">-->
<!--            <el-radio-button v-model="radio.index"  label="0">密码登录</el-radio-button>-->
<!--            <el-radio-button v-model="radio.index" label="1">验证码登录</el-radio-button>-->
<!--          </el-radio-group>-->
<!--        </div>-->
        <!--v-if="radio.index==0"-->
        <div class="ub ub-ver uw ub-f1" >
          <el-form  :model="form" :rules="rules" ref="form" label-width="0px" >
            <el-form-item class="umar-t32" label="" prop="uname">
              <el-input clearable size="large" autofocus v-model="form.uname" placeholder="请输入账号"></el-input>
            </el-form-item>
            <el-form-item class="umar-t32" label="" prop="pword">
              <el-input clearable size="large" v-model="form.pword" type="password" placeholder="请输入密码"></el-input>
            </el-form-item>
            <el-form-item class="umar-t32" label="" prop="code">
              <div class="ub ub-ac uw">
                <el-input clearable size="large" class="ub ub-f1 umar-r20"  @keyup.enter.native="toLogin('form')" v-model.number="form.code" placeholder="请输入验证码"></el-input>
                <img class="ub uh-32"  v-bind:src="getCodeUrl" @click="getCode()" alt="">
              </div>
            </el-form-item>
          </el-form>
          <el-button class="ub uw umar-t20 ubor-r ufs-18"  size="large" type="primary" @click="toLogin()">登录</el-button>
        </div>
        <!--验证码登录-->
        <div class="ub ub-ver" v-if="radio.index==1">
          <el-form  :model="form" :rules="rules2" ref="form2" label-width="0px" >
            <el-form-item class="umar-t32" label="" prop="phone">
              <el-input clearable size="large" autofocus maxlength="11" v-model="form.phone" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item class="umar-t32" label="" prop="phoneCode">
              <div class="ub ub-ac uw">
                <el-input clearable size="large" class="ub ub-f1 umar-r20" maxlength="4"  @keyup.enter.native="toLogin()" v-model.number="form.phoneCode" placeholder="请输入短信验证码"></el-input>
                <el-button type="warning" v-if="!code.doing" @click="getPhoneCode()" >获取验证码</el-button>
                <div class="ub uc-grey" v-if="code.doing">{{code.countdown}}秒后重新获取</div>
              </div>
            </el-form-item>
          </el-form>
          <el-button class="ub uw umar-t20 ubor-r ufs-18"  size="large" type="primary" @click="toLogin()">登录</el-button>
        </div>

      </div>
    </div>

    <div class="ufix-b uw" style="position: fixed;bottom: 20px">
      <div class="ub ub-pc upad-10">
         <span style="color: #ffffff;">
          Copyright ©2025 深圳市龙兄弟数码锁有限公司  版权所有
          <a style="color: #666;text-decoration: none;" target="_blank"
             href="https://beian.miit.gov.cn/" rel="nofollow" looyu_bound="1">粤ICP备18016736号</a>
        </span>
      </div>
    </div>

  </div>
</template>

<script type="text/ecmascript-6">
  import router from '@/router'
  import ApiMixin from '../../assets/js/apis.js'
  import UtilsMixin from '../../assets/js/utils.js'
  export default {
    data() {
      return {
        getCodeUrl:'',
        radio:{
          index:0
        },
        code:{
          doing:false,
          countdown:60,
        },
        form:{
          uname:'',
          pword:'',
          code:'',
          phone:'',
          phoneCode:''
        },
        rules: {
          uname: [
            {required: true, message: '账号不能为空', trigger: 'change'},
            {min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'change'}
          ],
          pword: [
            {required: true, message: '密码不能为空', trigger: 'change'},
            {min: 4, max: 20, message: '长度在 4 到 20个字符', trigger: 'change'},
          ],
          code: [
            { required: true, message: '验证码不能为空'},
            { type: 'number', message: '验证码必须为数字值'},
          ],
        },
        rules2: {
          phone: [
            {required: true, message: '手机号不能为空', trigger: 'change'},
          ],
          phoneCode: [
            { required: true, message: '验证码不能为空'},
            { type: 'number', message: '验证码必须为数字值'},
          ],
        },
      }
    },
    methods: {
      enterToLogin (e) {
        e.keyCode === 13 && this.toLogin()
      },
      getPhoneCode(){
        const that = this
        if (that.code.doing){
          return
        }
        if(!this.isPhone(this.form.phone)){
          that.$message({message: '手机号不正确',type: 'error'})
          return
        }
        const params = {
          phone:this.form.phone,
          code:this.form.phoneCode,
        }
        that.postService('base/getPhoneCode',params).then((res) => {
          if(res.code!=0){
            that.$message({message: res.message,type: 'error'})
            return
          }
          that.code = { doing: true, countdown: 60}
          that.$message({ message: '验证码已发送',type: 'success'})
          const inter = setInterval(function () {
            if (that.code.countdown <= 1) {
              clearInterval(inter)
              that.code = { doing: false, countdown: 60}
              return
            }
            let num = that.code.countdown - 1
            that.code = {
              doing: true,
              countdown: num
            }
          }, 1000)
        }).catch((err) => {
          console.log('err', err)
        })
      },
      toLogin(){
        if(this.radio.index==0){  // 密码登录
          this.$refs['form'].validate((valid) => {
            if(!valid){
              return
            }
            this.toLoginToPword()
          })
        }else{ // 验证码登录
          this.$refs['form2'].validate((valid) => {
            if(!valid){
              return
            }
            this.toLoginToCode()
          })
        }
      },
      toLoginToPword(){
        const params = {
          phone:this.form.uname,
          pword:this.form.pword,
          code:this.form.code,
        }
        this.postService('base/login',params).then((res) => {
          console.log(res)
          if(res.code!=0){
            this.$message({
              message: res.message,
              type: 'error'
            });
            return
          }
          this.$message({
            message: '登录成功',
            type: 'success'
          });
          sessionStorage.setItem('token',res.data.token)
          sessionStorage.setItem('user',JSON.stringify(res.data))
          router.push('/home/main')
        })
      },
      toLoginToCode(){
        if(!this.isPhone(this.form.phone)){
          this.$message({message: '手机号不正确',type: 'error'})
          return
        }
        const params = {
          phone:this.form.phone,
          code:this.form.phoneCode,
        }
        this.postService('base/loginCode',params).then((res) => {
          if(res.code!=0){
            this.$message({
              message: res.message,
              type: 'error'
            });
            return
          }
          this.$message({
            message: '登录成功',
            type: 'success'
          })
          sessionStorage.setItem('token',res.data.token)
          sessionStorage.setItem('user',JSON.stringify(res.data))
          router.push('/home/main')
        })
      },
      getCode(){
        this.getCodeUrl = this.getHost()+'/org/base/getCode/'+Math.random()
      },
    },
    created() {
      this.getCode()
    },
    mixins: [ ApiMixin,UtilsMixin],
  }
</script>



// WEBPACK FOOTER //
// login.vue?e15ba948